/* Arnold & Co custom: play product tile hover videos on hover */
(function () {
  function tileVideos(tile) {
    return tile.querySelectorAll('.grid-product__video-hover video');
  }
  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var tile = e.target.closest('.grid-product');
    if (!tile) return;
    tileVideos(tile).forEach(function (v) {
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });
  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var tile = e.target.closest('.grid-product');
    if (!tile) return;
    if (e.relatedTarget && tile.contains(e.relatedTarget)) return;
    tileVideos(tile).forEach(function (v) { v.pause(); v.currentTime = 0; });
  });
})();

/* COMPLETE WITH - add a recommended chain from the cart drawer.
   Delegated on document so it survives the drawer re-rendering its markup.
   Uses fetch() rather than a form so Cowlendar's /cart/add form hook is not
   triggered for what is a plain in-stock chain. */
(function () {
  var busy = false;
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-cw-add]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    var id = parseInt(btn.getAttribute('data-cw-add'), 10);
    if (!id) return;
    busy = true;
    btn.classList.add('is-loading');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) { throw new Error('add failed ' + r.status); } return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        if (window.console) { console.warn('[complete-with]', err); }
        btn.classList.remove('is-loading');
        btn.disabled = false;
      })
      .then(function () { busy = false; });
  });
})();

/* COMPLETE WITH - slider arrows */
(function () {
document.addEventListener('click', function (e) {
var arrow = e.target.closest('.cw__arrow');
if (!arrow) { return; }
e.preventDefault();
var slider = arrow.parentNode;
var track = slider.querySelector('[data-cw-track]');
if (!track) { return; }
var dir = arrow.classList.contains('cw__arrow--next') ? 1 : -1;
track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
});
})();

/* COMPLETE WITH (BANDS) */
(function () {
var AB_SKU = 'AB';
var WORKER = 'https://infinity-ring-orders.arnold-co-jewellery.workers.dev';
function money(n){ return '$' + Number(n).toLocaleString('en-AU',{minimumFractionDigits:2,maximumFractionDigits:2}); }

document.addEventListener('click', function (e) {
var btn = e.target.closest('[data-cwb-add]');
if (!btn || btn.disabled) { return; }
e.preventDefault();
e.stopPropagation();
var props = {};
var size = btn.getAttribute('data-cw-size');
var karat = btn.getAttribute('data-cw-karat');
if (size) { props['Ring Size'] = size; }
if (karat) { props['Metal Karat'] = karat; }
var label = btn.textContent;
btn.disabled = true;
btn.classList.add('is-loading');
btn.textContent = 'Adding';
fetch('/cart/add.js', {
method: 'POST',
credentials: 'same-origin',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: btn.getAttribute('data-cwb-add'), quantity: 1, properties: props }] })
})
.then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
.then(function () { document.dispatchEvent(new CustomEvent('cart:build')); openCartDrawer(); })
.catch(function (err) {
if (window.console) { console.warn('[complete-with-band]', err); }
btn.disabled = false;
btn.classList.remove('is-loading');
btn.textContent = label;
});
});

function openCartDrawer() {
var d = document.getElementById('CartDrawer');
if (d && d.className.indexOf('drawer--is-open') !== -1) { return; }
var t = document.querySelector('.js-drawer-open-cart');
if (t) { t.click(); }
}

/* ── Infinity plain band live quote ─────────────────────────────────────────
   The worker proxies Infinity's price endpoint at /proxy/price and forwards the
   query string untouched. The band is always 2mm wide, 1.5mm thick, polished,
   all three metal zones the same; only metal, purity and finger size vary, and
   both of those are inherited from the engagement ring already in the cart.
   Purity is whitelisted on purpose - Infinity answers unsupported values (10ct)
   with a nonsense price rather than an error. */
var PRICE_URL = WORKER + '/proxy/price';
var AB_WIDTH_MM = '2';
var AB_THICKNESS_MM = '1.5';
var AB_SURFACE = 'Polished';
var AB_PURITY = { '9': '9ct', '14': '14ct', '18': '18ct' };
var AB_METALS = ['Yellow Gold', 'White Gold', 'Rose Gold'];

function abSpec(card) {
  var colour = (card.getAttribute('data-ab-colour') || '').trim();
  var material = card.getAttribute('data-ab-material') || '';
  var size = (card.getAttribute('data-ab-size') || '').replace(/\s+/g, '');
  if (!size) { return null; }
  var metal, purity;
  if (colour === 'Platinum') {
    metal = 'Platinum';
    purity = '950';
  } else {
    if (AB_METALS.indexOf(colour) === -1) { return null; }
    var k = material.match(/(\d+)\s*K/i);
    if (!k) { return null; }
    purity = AB_PURITY[k[1]];
    if (!purity) { return null; }
    metal = colour;
  }
  return { metal: metal, purity: purity, size: size, width: AB_WIDTH_MM, thickness: AB_THICKNESS_MM, surface: AB_SURFACE };
}

function abQuery(s) {
  var p = [
    'SKU=' + encodeURIComponent(AB_SKU),
    'size=' + encodeURIComponent(s.size),
    'fingerSize=' + encodeURIComponent(s.size),
    'width=' + encodeURIComponent(s.width),
    'thickness=' + encodeURIComponent(s.thickness),
    'metalGroups=' + encodeURIComponent('[]')
  ];
  for (var i = 0; i < 3; i++) {
    var z = 'metalZones' + encodeURIComponent('[' + i + ']');
    p.push(z + encodeURIComponent('[id]') + '=' + (i + 1));
    p.push(z + encodeURIComponent('[material]') + '=' + encodeURIComponent(s.metal));
    p.push(z + encodeURIComponent('[surface]') + '=' + encodeURIComponent(s.surface));
    p.push(z + encodeURIComponent('[purity]') + '=' + encodeURIComponent(s.purity));
  }
  p.push('additionalData' + encodeURIComponent('[discount]') + '=0');
  p.push('additionalData' + encodeURIComponent('[store_rrp]') + '=');
  return p.join('&');
}

function quoteAB(card) {
  if (card.__abDone) { return; }
  card.__abDone = true;
  var priceEl = card.querySelector('[data-ab-price]');
  var btn = card.querySelector('[data-cw-ab-order]');
  function enquire() {
    priceEl.textContent = 'Price on request';
    btn.disabled = false;
    btn.textContent = 'Enquire';
  }
  var spec = abSpec(card);
  if (!spec) { enquire(); return; }
  fetch(PRICE_URL + '?' + abQuery(spec), { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (!d || d.error || !d.price) { throw new Error('no price'); }
      card.setAttribute('data-ab-quoted', d.price);
      card.setAttribute('data-ab-params', abQuery(spec));
      card.setAttribute('data-ab-metal', spec.metal);
      card.setAttribute('data-ab-purity', spec.purity);
      card.setAttribute('data-ab-fingersize', spec.size);
      card.setAttribute('data-ab-thickness', spec.thickness);
      priceEl.textContent = money(d.price);
      btn.disabled = false;
      btn.textContent = card.getAttribute('data-ab-variant') && card.getAttribute('data-ab-variant') !== '0' ? 'Add to cart' : 'Enquire';
    })
    .catch(function (err) {
      if (window.console) { console.warn('[complete-with-band] AB quote', err); }
      enquire();
    });
}

function scanAB() {
var cards = document.querySelectorAll('[data-cw-ab]');
for (var i = 0; i < cards.length; i++) { quoteAB(cards[i]); }
}
document.addEventListener('cart:build', function () { setTimeout(scanAB, 300); });
document.addEventListener('DOMContentLoaded', scanAB);
setTimeout(scanAB, 800);

document.addEventListener('click', function (e) {
var b = e.target.closest('[data-cw-ab-order]');
if (!b) { return; }
e.preventDefault();
var card = b.closest('[data-cw-ab]');
document.dispatchEvent(new CustomEvent('cw:ab-order', { detail: {
sku: AB_SKU,
material: card.getAttribute('data-ab-material'),
width: card.getAttribute('data-ab-width'),
size: card.getAttribute('data-ab-size'),
colour: card.getAttribute('data-ab-colour'),
price: card.getAttribute('data-ab-quoted') || null,
ring: card.getAttribute('data-ab-ring')
} }));

var variantId = card.getAttribute('data-ab-variant');
var quoted = card.getAttribute('data-ab-quoted');
if (!variantId || variantId === '0' || !quoted) {
window.location.href = '/products/ab';
return;
}

/* The placeholder sits in the cart at $0 and carries every value the draft order
   needs. Underscore-prefixed properties are stored but hidden from the customer. */
var props = {
'Metal': card.getAttribute('data-ab-metal') + ' ' + card.getAttribute('data-ab-purity'),
'Width': card.getAttribute('data-ab-width'),
'Thickness': card.getAttribute('data-ab-thickness') + 'mm',
'Finish': 'Polished',
'Ring Size': card.getAttribute('data-ab-size'),
'Made for': card.getAttribute('data-ab-ring'),
'_sku': AB_SKU,
'_infinity_metal': card.getAttribute('data-ab-metal'),
'_infinity_purity': card.getAttribute('data-ab-purity'),
'_infinity_width': String(card.getAttribute('data-ab-width') || '').replace('mm', ''),
'_infinity_thickness': card.getAttribute('data-ab-thickness'),
'_infinity_surface': 'Polished',
'_infinity_finger_size': card.getAttribute('data-ab-fingersize'),
'_infinity_price': quoted,
'_infinity_params': card.getAttribute('data-ab-params') || ''
};

b.disabled = true;
var label = b.textContent;
b.textContent = 'Adding';
fetch('/cart/add.js', {
method: 'POST',
credentials: 'same-origin',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: props }] })
})
.then(function (r) { if (!r.ok) { throw new Error('add failed ' + r.status); } return r.json(); })
.then(function () { document.dispatchEvent(new CustomEvent('cart:build')); })
.catch(function (err) {
if (window.console) { console.warn('[complete-with-band] AB add', err); }
b.disabled = false;
b.textContent = label;
});
});
})();

/* CART DRAWER FALLBACK - the options app submits the product form itself
   (form.submit(), which fires no submit event), so Motion's ajax binding never
   sees it and the browser lands on /cart. Take over both routes: the submit
   event when nothing else handles it, and any programmatic form.submit() to
   /cart/add. Everything else is left alone. */
(function () {
  var busy = false;

  function drawerCart() {
    return !!(window.theme && theme.settings && theme.settings.cartType === 'drawer');
  }

  function isCartForm(form) {
    return drawerCart() && form && form.tagName === 'FORM' && (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }

  function openDrawer() {
    var d = document.getElementById('CartDrawer');
    if (d && d.className.indexOf('drawer--is-open') !== -1) { return; }
    var t = document.querySelector('.js-drawer-open-cart');
    if (t) { t.click(); }
  }

  function ajaxAdd(form, onFail) {
    if (busy) { return; }
    busy = true;
    var btn = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) { throw new Error('add failed ' + r.status); } return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(openDrawer, 200);
      })
      .catch(function (err) {
        if (window.console) { console.warn('[cart-fallback]', err); }
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (onFail) { onFail(); }
      })
      .then(function () { busy = false; });
  }

  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (isCartForm(this)) {
      var form = this;
      ajaxAdd(form, function () { nativeSubmit.call(form); });
      return;
    }
    return nativeSubmit.apply(this, arguments);
  };

  function openIfFlagged() {
    try {
      if (sessionStorage.getItem('acOpenCart') !== '1') { return; }
      sessionStorage.removeItem('acOpenCart');
      setTimeout(openDrawer, 400);
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openIfFlagged);
  } else {
    openIfFlagged();
  }

  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) { return; }
    if (!isCartForm(e.target)) { return; }
    e.preventDefault();
    var form = e.target;
    ajaxAdd(form, function () { nativeSubmit.call(form); });
  });
})();


/* TEMPORARY - add ?irdebug=1 to any Infinity ring product URL to see the exact
   price request the configurator makes. Remove once the quote endpoint is built. */
(function () {
  if (window.location.search.indexOf('irdebug=1') === -1) { return; }
  var box = document.createElement('div');
  box.style.cssText = 'position:fixed;left:10px;bottom:10px;z-index:2147483647;max-width:520px;max-height:60vh;overflow:auto;background:#111;color:#0f0;font:11px/1.45 monospace;padding:10px 12px;border-radius:6px;white-space:pre-wrap;word-break:break-all;box-shadow:0 4px 20px rgba(0,0,0,.4)';
  box.textContent = 'IR DEBUG: waiting for a price from the configurator...';
  function add(t) {
    if (box.textContent.indexOf('waiting for') !== -1) { box.textContent = ''; }
    box.textContent += t + '\n\n';
  }
  window.addEventListener('message', function (e) {
    if (!e.data || typeof e.data !== 'object') { return; }
    if (e.data.type === 'infinityPriceUpdate') {
      add('PRICE: ' + e.data.price + '\nPARAMS: ' + e.data.params);
    }
  });
  if (document.body) { document.body.appendChild(box); }
  else { document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(box); }); }
})();


/* ══ MADE-TO-ORDER INFINITY BANDS IN THE CART ══════════════════════════════
   The band sits on a $0 placeholder variant; the real figure is the quote
   stored on the line as _infinity_price. Two jobs here:
     1. keep the drawer subtotal honest (the options app rewrites it, so we
        re-apply on every change rather than fighting for the last word)
     2. take over CHECKOUT whenever a band is in the cart, and raise an
        Infinity draft order for the band AND everything else in the cart.
   Fails closed: if the draft order cannot be created, checkout is blocked
   rather than letting a $0 band through Shopify's own checkout. */
(function () {
  var ORDER_URL = 'https://infinity-ring-orders.arnold-co-jewellery.workers.dev';
  var expectedSubtotal = null;

  function fmt(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  /* Anything that must never reach Shopify's own checkout. Keyed on the product,
     not just our properties - the $0 placeholder variants are publicly addressable,
     so a line added straight from /products/ab-w would otherwise slip through free. */
  var MADE_TO_ORDER = ['ab', 'ab-w'];
  function blockingLines(cart) {
    return (cart.items || []).filter(function (i) {
      return MADE_TO_ORDER.indexOf(i.handle) !== -1 || (i.properties && i.properties._sku === 'AB');
    });
  }
  /* The subset we hold a live quote for and can therefore invoice. */
  function bandLines(cart) {
    return blockingLines(cart).filter(function (i) {
      return i.properties && i.properties._infinity_price;
    });
  }

  function bandTotalCents(cart) {
    return bandLines(cart).reduce(function (sum, i) {
      return sum + Math.round(parseFloat(i.properties._infinity_price) * 100) * i.quantity;
    }, 0);
  }

  /* ── 1. subtotal ─────────────────────────────────────────────────────── */
  function paintSubtotal(extraCents) {
    var el = document.querySelector('[data-subtotal]');
    if (!el || !extraCents) { return; }
    var text = el.textContent.trim();
    if (text === expectedSubtotal) { return; }
    var base = parseFloat(text.replace(/[^0-9.]/g, ''));
    if (isNaN(base)) { return; }
    expectedSubtotal = fmt(Math.round(base * 100) + extraCents);
    el.textContent = expectedSubtotal;
  }

  function refreshSubtotal() {
    getCart().then(function (cart) {
      var extra = bandTotalCents(cart);
      expectedSubtotal = null;
      if (!extra) { return; }
      paintSubtotal(extra);
      var el = document.querySelector('[data-subtotal]');
      if (el && !el.__cwWatched) {
        el.__cwWatched = true;
        new MutationObserver(function () { paintSubtotal(extra); }).observe(el, { childList: true, subtree: true, characterData: true });
      }
    }).catch(function () {});
  }
  document.addEventListener('cart:build', function () { setTimeout(refreshSubtotal, 400); });
  document.addEventListener('cart:updated', function () { setTimeout(refreshSubtotal, 400); });
  setTimeout(refreshSubtotal, 900);

  /* ── 2. checkout ─────────────────────────────────────────────────────── */
  function modal() {
    var wrap = document.getElementById('cwOrderModal');
    if (wrap) { return wrap; }
    wrap = document.createElement('div');
    wrap.id = 'cwOrderModal';
    wrap.setAttribute('hidden', '');
    wrap.innerHTML =
      '<div class="cw-modal__bg" data-cw-close></div>' +
      '<div class="cw-modal__panel" role="dialog" aria-modal="true" aria-label="Complete your made-to-order request">' +
        '<button type="button" class="cw-modal__x" data-cw-close aria-label="Close">&times;</button>' +
        '<h2 class="cw-modal__title">Made to order</h2>' +
        '<p class="cw-modal__intro">Your band is made to order, we require a few details from you to get started on your order!</p>' +
        '<div class="cw-modal__lines" data-cw-lines></div>' +
        '<label class="cw-modal__label">Name<input type="text" data-cw-name autocomplete="name" required></label>' +
        '<label class="cw-modal__label">Email<input type="email" data-cw-email autocomplete="email" required></label>' +
        '<label class="cw-modal__label">Phone<input type="tel" data-cw-phone autocomplete="tel"></label>' +
        '<label class="cw-modal__label">Anything we should know?<textarea data-cw-note rows="2"></textarea></label>' +
        '<div class="cw-modal__err" data-cw-err hidden></div>' +
        '<button type="button" class="cw-modal__go" data-cw-submit>Begin your order!</button>' +
      '</div>';
    document.body.appendChild(wrap);
    var css = document.createElement('style');
    css.textContent =
      '#cwOrderModal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;}' +
      '#cwOrderModal[hidden]{display:none;}' +
      '.cw-modal__bg{position:absolute;inset:0;background:rgba(0,0,0,.45);}' +
      '.cw-modal__panel{position:relative;background:#fff;max-width:420px;width:calc(100% - 32px);max-height:90vh;overflow:auto;padding:28px 26px;box-shadow:0 10px 40px rgba(0,0,0,.25);}' +
      '.cw-modal__x{position:absolute;top:8px;right:12px;border:0;background:none;font-size:24px;line-height:1;cursor:pointer;}' +
      '.cw-modal__title{font-size:16px;letter-spacing:2.4px;text-transform:uppercase;margin:0 0 10px;}' +
      '.cw-modal__intro{font-size:13px;line-height:19px;margin:0 0 14px;}' +
      '.cw-modal__lines{font-size:12px;line-height:18px;border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;padding:10px 0;margin:0 0 14px;}' +
      '.cw-modal__label{display:block;font-size:11px;letter-spacing:1.5px;text-transform:uppercase;margin:0 0 10px;}' +
      '.cw-modal__label input,.cw-modal__label textarea{display:block;width:100%;margin-top:4px;padding:8px 10px;border:1px solid #ccc;font-size:14px;letter-spacing:0;text-transform:none;}' +
      '.cw-modal__err{background:#fdeaea;color:#8a1f1f;font-size:12px;line-height:18px;padding:8px 10px;margin:0 0 12px;}' +
      '.cw-modal__go{width:100%;border:0;background:#1e1e1e;color:#fff;padding:12px;font-size:11px;letter-spacing:2.7px;text-transform:uppercase;cursor:pointer;}' +
      '.cw-modal__go[disabled]{opacity:.5;cursor:default;}';
    document.head.appendChild(css);
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-cw-close]')) { wrap.setAttribute('hidden', ''); }
    });
    return wrap;
  }

  function openModal(cart) {
    var wrap = modal();
    var lines = wrap.querySelector('[data-cw-lines]');
    var html = '';
    (cart.items || []).forEach(function (i) {
      var p = (i.properties && i.properties._infinity_price)
        ? fmt(Math.round(parseFloat(i.properties._infinity_price) * 100) * i.quantity)
        : fmt(linePriceCents(i) * i.quantity);
      html += '<div>' + i.product_title + ' &mdash; ' + p + '</div>';
    });
    lines.innerHTML = html;
    wrap.querySelector('[data-cw-err]').hidden = true;
    wrap.removeAttribute('hidden');
    var email = wrap.querySelector('[data-cw-email]');
    if (email) { email.focus(); }
  }

  /* The options app does not put its surcharges into Shopify's cart price - it
     encodes them in the property text ("Metal Karat: Platinum | $600.00") and only
     materialises them as a separate line during its own checkout, which we bypass.
     So read them back out of the properties, or the invoice undercharges. */
  function surchargeCents(item) {
    var props = item.properties || {};
    var total = 0;
    Object.keys(props).forEach(function (k) {
      var v = String(props[k] == null ? '' : props[k]);
      var m = v.match(/\|\s*\$\s*([0-9][0-9,]*(?:\.[0-9]{2})?)/);
      if (m) { total += Math.round(parseFloat(m[1].replace(/,/g, '')) * 100); }
    });
    return total;
  }

  function linePriceCents(item) {
    return (item.final_price || item.price || 0) + surchargeCents(item);
  }

  function payload(cart, band, fields) {
    var p = band.properties;
    return {
      customer_email: fields.email,
      customer_name: fields.name,
      customer_phone: fields.phone,
      customer_note: fields.note,
      product_title: 'Infinity Plain Band',
      model_code: p._sku,
      infinity_price: parseFloat(p._infinity_price),
      ring_params: p._infinity_params,
      band: {
        sku: p._sku,
        variant_id: band.variant_id,
        product_title: 'Infinity Plain Band',
        metal: p._infinity_metal,
        purity: p._infinity_purity,
        width_mm: p._infinity_width,
        thickness_mm: p._infinity_thickness,
        surface: p._infinity_surface,
        finger_size: p._infinity_finger_size,
        quoted_price: parseFloat(p._infinity_price),
        ring_params: p._infinity_params
      },
      cart_items: (cart.items || []).filter(function (i) { return i.key !== band.key; }).map(function (i) {
        return {
          variant_id: i.variant_id,
          quantity: i.quantity,
          title: i.product_title,
          properties: i.properties || {},
          price: (linePriceCents(i) / 100).toFixed(2)
        };
      })
    };
  }

  function submit(cart, band) {
    var wrap = modal();
    var btn = wrap.querySelector('[data-cw-submit]');
    var err = wrap.querySelector('[data-cw-err]');
    var fields = {
      name: wrap.querySelector('[data-cw-name]').value.trim(),
      email: wrap.querySelector('[data-cw-email]').value.trim(),
      phone: wrap.querySelector('[data-cw-phone]').value.trim(),
      note: wrap.querySelector('[data-cw-note]').value.trim()
    };
    function fail(msg) {
      err.textContent = msg;
      err.hidden = false;
      btn.disabled = false;
      btn.textContent = 'Begin your order!';
    }
    if (!fields.name || !fields.email) { fail('Please enter your name and email.'); return; }
    err.hidden = true;
    btn.disabled = true;
    btn.textContent = 'Sending';
    fetch(ORDER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload(cart, band, fields))
    })
      .then(function (r) { return r.json().catch(function () { return { success: false, error: 'Unexpected response (' + r.status + ')' }; }); })
      .then(function (d) {
        if (d && d.success && d.invoice_url) { window.location.href = d.invoice_url; return; }
        fail(d && d.error ? d.error : 'We could not raise the invoice. Please try again or call us.');
      })
      .catch(function () { fail('Connection problem. Please try again or call us.'); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }
    if (e.target.closest('[data-cw-invoice]')) {
      e.preventDefault();
      e.stopPropagation();
      getCart().then(function (cart) {
        var all = blockingLines(cart);
        var b = bandLines(cart);
        if (!all.length) { guardCheckout(false); return; }
        if (all.length > b.length) {
          alert('One of the made-to-order bands in your bag has no price against it. Please remove it and add the band from the suggestions under your ring, or call us and we will sort it out.');
          return;
        }
        if (b.length > 1) { alert('Please order made-to-order bands one at a time.'); return; }
        openModal(cart);
      });
      return;
    }
    if (e.target.closest('[data-cw-submit]')) {
      e.preventDefault();
      getCart().then(function (cart) {
        var b = bandLines(cart);
        if (b.length) { submit(cart, b[0]); }
      });
      return;
    }
    var go = e.target.closest('[name="checkout"], .cart__checkout');
    if (!go) { return; }
    /* Decided synchronously off a cached flag - we cannot await inside a click
       and still be allowed to cancel the form submit. */
    if (!window.__cwHasBand) { return; }
    e.preventDefault();
    e.stopPropagation();
    getCart().then(function (cart) {
      var b = bandLines(cart);
      if (!b.length) { window.__cwHasBand = false; return; }
      if (b.length > 1) { alert('Please order made-to-order bands one at a time.'); return; }
      openModal(cart);
    });
  }, true);

  /* The click interception below is a second line of defence only. The real
     guard is this: while a made-to-order band is in the cart the native
     checkout button and the express wallet buttons are removed outright, so
     there is no route into Shopify's own checkout for a $0 line. */
  function guardCheckout(has) {
    var wraps = document.querySelectorAll('.cart__checkout-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var native = w.querySelector('[name="checkout"]');
      var extra = w.querySelector('.additional-checkout-buttons');
      var ours = w.querySelector('[data-cw-invoice]');
      if (has) {
        if (native) { native.disabled = true; native.style.display = 'none'; }
        if (extra) { extra.style.display = 'none'; }
        if (!ours) {
          ours = document.createElement('button');
          ours.type = 'button';
          ours.className = 'btn cart__checkout';
          ours.setAttribute('data-cw-invoice', '');
          ours.textContent = 'Begin your order!';
          w.insertBefore(ours, w.firstChild);
        }
        ours.style.display = '';
      } else {
        if (native) { native.disabled = false; native.style.display = ''; }
        if (extra) { extra.style.display = ''; }
        if (ours) { ours.style.display = 'none'; }
      }
    }
  }

  function flagBand() {
    getCart().then(function (cart) {
      window.__cwHasBand = blockingLines(cart).length > 0;
      guardCheckout(window.__cwHasBand);
    }).catch(function () {});
  }
  document.addEventListener('cart:build', function () { setTimeout(flagBand, 300); });
  document.addEventListener('cart:updated', function () { setTimeout(flagBand, 300); });
  flagBand();
})();


/* ══ PROFESSIONAL CARE PLAN ══════════════════════════════════════════════
   The bracket follows the price the customer can see - sale prices and
   option surcharges included. When a term is picked, the matching care-plan
   variant is added right after the piece itself lands in the cart. */
(function () {
  var box = document.querySelector('[data-acp]');
  if (!box) { return; }
  var VDATA;
  try { VDATA = JSON.parse(document.querySelector('[data-acp-variants]').textContent); } catch (e) { return; }

  function bandFor(cents) {
    var d = cents / 100;
    if (d < 1000) { return null; }
    if (d < 2000) { return '$1,000 – $2,000'; }
    if (d < 3000) { return '$2,000 – $3,000'; }
    if (d < 4000) { return '$3,000 – $4,000'; }
    if (d < 5000) { return '$4,000 – $5,000'; }
    if (d < 6000) { return '$5,000 – $6,000'; }
    if (d < 8000) { return '$6,000 – $8,000'; }
    if (d < 10000) { return '$8,000 – $10,000'; }
    if (d < 15000) { return '$10,000 – $15,000'; }
    if (d < 20000) { return '$15,000 – $20,000'; }
    if (d < 30000) { return '$20,000 – $30,000'; }
    return '$30,000 +';
  }
  function variantFor(term, band) {
    for (var i = 0; i < VDATA.length; i++) {
      if (VDATA[i].term === term && VDATA[i].band === band) { return VDATA[i]; }
    }
    return null;
  }
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  }

  /* The live price - whatever the customer can actually buy at right now.
     Sale layouts show the original crossed out next to the sale figure, so of
     all the prices on display we take the LOWEST: the sale price is the one
     the bracket follows. */
  function displayedCents() {
    var els = document.querySelectorAll('[data-product-price], .product__price, .product__price--sale, .sale-price');
    var best = 0;
    for (var i = 0; i < els.length; i++) {
      var matches = els[i].textContent.match(/\$\s*[0-9][0-9,]*(?:\.[0-9]{2})?/g) || [];
      for (var j = 0; j < matches.length; j++) {
        var n = parseFloat(matches[j].replace(/[^0-9.]/g, ''));
        if (!isNaN(n) && n > 0 && (best === 0 || n < best)) { best = n; }
      }
    }
    if (best > 0) { return Math.round(best * 100); }
    return parseInt(box.getAttribute('data-acp-price'), 10) || 0;
  }

  var currentBand = null;
  function refresh() {
    var band = bandFor(displayedCents());
    currentBand = band;
    if (!band) { box.setAttribute('hidden', ''); return; }
    box.removeAttribute('hidden');
    var v3 = variantFor('3-Year Plan', band), v10 = variantFor('10-Year Plan', band);
    var e3 = box.querySelector('[data-acp-price-3]'), e10 = box.querySelector('[data-acp-price-10]');
    if (v3 && e3) { e3.textContent = money(v3.price); }
    if (v10 && e10) { e10.textContent = money(v10.price); }
  }
  refresh();
  var priceEl = document.querySelector('[data-product-price], .product__price');
  if (priceEl && priceEl.parentNode) {
    new MutationObserver(refresh).observe(priceEl.parentNode, {childList: true, subtree: true, characterData: true});
  }
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('form[action*="/cart/add"]')) { setTimeout(refresh, 250); } });

  /* The apps on some product pages take over the add themselves - options
     validation, cloned forms, delayed submits - so nothing captured at click
     time can be trusted. Instead: note WHEN they last tried to add, and let
     attach() read the radio as it stands the moment the piece lands. */
  var lastAddClick = 0;
  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }
    if (!e.target.closest('[data-add-to-cart], form[action*="/cart/add"] [type="submit"]')) { return; }
    lastAddClick = Date.now();
    [1200, 2500, 4500, 7000, 10000, 15000].forEach(function (ms) { setTimeout(attach, ms); });
  }, true);

  /* ...and attach the plan once the piece has actually landed */
  var adding = false, attached = false;
  function attach() {
    if (adding || attached) { return; }
    if (Date.now() - lastAddClick > 60000) { return; }
    var sel = box.querySelector('input[name="acp_plan"]:checked');
    if (!sel || !sel.value || !currentBand) { return; }
    var v = variantFor(sel.value, currentBand);
    if (!v) { return; }
    var handle = box.getAttribute('data-acp-handle');
    var p = {
      variant: v.id, term: sel.value, band: currentBand,
      title: box.getAttribute('data-acp-title'), handle: handle
    };
    fetch('/cart.js', {credentials: 'same-origin', cache: 'no-store'}).then(function (r) { return r.json(); }).then(function (cart) {
      var covered = (cart.items || []).some(function (i) { return i.handle === p.handle; });
      var already = (cart.items || []).some(function (i) { return i.properties && i.properties._acp_for === p.handle && i.handle === 'jewellery-care-plan'; });
      if (already) { attached = true; return; }
      if (!covered) { return; }
      adding = true;
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: p.variant, quantity: 1, properties: {
          '_acp_covers': p.title, '_acp_plan': p.term, '_acp_band': p.band, '_acp_for': p.handle
        }}]})
      }).then(function (r) { if (!r.ok) { throw new Error('acp add ' + r.status); } return r.json(); })
        .then(function () { attached = true; document.dispatchEvent(new CustomEvent('cart:build')); })
        .catch(function (err) { if (window.console) { console.warn('[care-plan]', err); } })
        .then(function () { adding = false; });
    }).catch(function () {});
  }
  document.addEventListener('cart:build', function () { setTimeout(attach, 500); });
  document.addEventListener('cart:updated', function () { setTimeout(attach, 500); });
})();


/* === ACP: cart-drawer care plan upsell === */
(function(){
'use strict';
var PLAN='jewellery-care-plan',MIN=100000,vars=null,busy=false;
function esc(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML}
function fmt(c){var n=Math.round(c)/100;return '$'+n.toLocaleString('en-AU',{minimumFractionDigits:0,maximumFractionDigits:2})}
function parseBand(l){var n=(l.match(/[\d,]+/g)||[]).map(function(s){return parseInt(s.replace(/,/g,''),10)*100});if(!n.length)return null;return{lo:n[0],hi:n.length>1?n[1]:1/0}}
function loadVars(cb){if(vars)return cb();fetch('/products/'+PLAN+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){if(!p)return;vars=p.variants.map(function(v){var b=parseBand(v.option2||'');return b?{id:v.id,term:v.option1,band:v.option2,lo:b.lo,hi:b.hi,price:v.price}:null}).filter(Boolean);cb()}).catch(function(){})}
function pick(t,c){for(var i=0;i<vars.length;i++){var v=vars[i];if(v.term.indexOf(t)===0&&c>=v.lo&&c<v.hi)return v}return null}
function render(){
var dr=document.getElementById('CartDrawer');if(!dr)return;
fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
var old=document.getElementById('acp-drawer');
var cov={};cart.items.forEach(function(i){if(i.handle===PLAN&&i.properties&&i.properties._acp_for)cov[i.properties._acp_for]=1});
var tgt=null;
cart.items.forEach(function(i){if(i.handle===PLAN)return;var u=(i.final_price!=null?i.final_price:i.price);if(u<MIN||cov[i.handle])return;if(!tgt||u>tgt.u)tgt={i:i,u:u}});
if(!tgt){if(old)old.remove();return}
loadVars(function(){
var v3=pick('3-Year',tgt.u),v10=pick('10-Year',tgt.u);if(!v3||!v10){if(old)old.remove();return}
var an=dr.querySelector('.cart__checkout-wrapper');if(!an)return;
var box=old;if(!box){box=document.createElement('div');box.id='acp-drawer';box.className='acp-d'}
box.innerHTML='<div class="acp-d__t">Professional Care Plan</div>'+'<div class="acp-d__s">Protect '+esc(tgt.i.product_title)+'</div>'+'<div class="acp-d__row">'+'<button type="button" class="acp-d__b" data-acp-add="'+v3.id+'">3-Year<small>'+fmt(v3.price)+'</small></button>'+'<button type="button" class="acp-d__b" data-acp-add="'+v10.id+'">10-Year<small>'+fmt(v10.price)+'</small></button>'+'</div>';
if(!box.parentNode)an.parentNode.insertBefore(box,an);
box.querySelectorAll('[data-acp-add]').forEach(function(b){
b.addEventListener('click',function(){
if(busy)return;busy=true;b.textContent='Adding\u2026';
var v=vars.filter(function(x){return String(x.id)===b.getAttribute('data-acp-add')})[0];
fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties:{_acp_plan:v.term,_acp_band:v.band,_acp_covers:tgt.i.product_title,_acp_for:tgt.i.handle}}]})})
.then(function(r){if(!r.ok)throw 0;document.dispatchEvent(new CustomEvent('cart:build'));document.dispatchEvent(new CustomEvent('cart:updated'))})
.catch(function(){}).then(function(){busy=false;setTimeout(sched,700)})
})
})
})
}).catch(function(){})
}
var t0=null;function sched(){clearTimeout(t0);t0=setTimeout(render,650)}
document.addEventListener('cart:build',sched);
document.addEventListener('cart:updated',sched);
document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.js-drawer-open-cart'))sched()},true);
setInterval(function(){var d=document.getElementById('CartDrawer');if(d&&d.className.indexOf('drawer--is-open')>-1&&!document.getElementById('acp-drawer'))sched()},2500);
sched();
})();
